import { render, staticRenderFns } from "./identify-woodlice.vue?vue&type=template&id=647ee07f&"
import script from "./identify-woodlice.vue?vue&type=script&lang=js&"
export * from "./identify-woodlice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BannerDefault: require('C:/Projects/mpc-nuxt-master/v8/nuxt/components/BannerDefault.vue').default,NavIcons: require('C:/Projects/mpc-nuxt-master/v8/nuxt/components/NavIcons.vue').default,SideBar: require('C:/Projects/mpc-nuxt-master/v8/nuxt/components/SideBar.vue').default})
